import { render, staticRenderFns } from "./ttBookingBasic.vue?vue&type=template&id=b66b00e2&scoped=true&"
import script from "./ttBookingBasic.vue?vue&type=script&lang=js&"
export * from "./ttBookingBasic.vue?vue&type=script&lang=js&"
import style0 from "./ttBookingBasic.vue?vue&type=style&index=0&id=b66b00e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b66b00e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b66b00e2')) {
      api.createRecord('b66b00e2', component.options)
    } else {
      api.reload('b66b00e2', component.options)
    }
    module.hot.accept("./ttBookingBasic.vue?vue&type=template&id=b66b00e2&scoped=true&", function () {
      api.rerender('b66b00e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/pageUserUICustom/ttBookingBasic.vue"
export default component.exports